import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lightning, Warning } from "@phosphor-icons/react";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("admin@bot.local");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(email.trim(), password);
    if (!res.ok) setError(res.error);
    setLoading(false);
  };

  return (
    <div className="min-h-screen w-full flex items-stretch bg-[#09090b]">
      <div className="hidden lg:flex flex-col justify-between w-1/2 border-r border-[#27272a] p-14 relative overflow-hidden">
        <div className="absolute inset-0 opacity-[0.04]" style={{ backgroundImage: "linear-gradient(#f4f4f5 1px, transparent 1px), linear-gradient(90deg, #f4f4f5 1px, transparent 1px)", backgroundSize: "32px 32px" }} />
        <div className="flex items-center gap-3 relative z-10">
          <div className="h-9 w-9 bg-cyan-500 flex items-center justify-center">
            <Lightning weight="fill" className="text-black" size={22} />
          </div>
          <span className="font-head text-lg font-semibold tracking-tight">MULTICHAIN&nbsp;<span className="text-cyan-400">SNIPER</span></span>
        </div>
        <div className="relative z-10">
          <h1 className="font-head text-4xl font-light tracking-tight leading-tight">
            Detect trending tokens.<br />Filter the scams.<br /><span className="text-cyan-400 font-semibold">Execute with guardrails.</span>
          </h1>
          <p className="text-[#a1a1aa] text-sm mt-6 max-w-md">
            Multi-chain screener + risk engine + auto-trading over Solana, Base, BNB, Ethereum, Monad & Robinhood chains.
          </p>
        </div>
        <div className="relative z-10 flex items-center gap-2 text-xs text-[#a1a1aa] font-mono">
          <Warning size={14} className="text-yellow-500" /> Trades run in a SIMULATED engine on real market data.
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <h2 className="font-head text-2xl font-semibold tracking-tight mb-1">Operator Access</h2>
          <p className="text-[#a1a1aa] text-sm mb-8">Single-user secure login.</p>

          <Label className="text-xs uppercase tracking-wide text-[#a1a1aa]">Username / Email</Label>
          <Input data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)}
            className="mt-1.5 mb-4 bg-[#18181b] border-[#27272a] rounded-none focus-visible:ring-cyan-500 font-mono text-sm" />

          <Label className="text-xs uppercase tracking-wide text-[#a1a1aa]">Password</Label>
          <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••" className="mt-1.5 mb-5 bg-[#18181b] border-[#27272a] rounded-none focus-visible:ring-cyan-500 font-mono text-sm" />

          {error && <p data-testid="login-error" className="text-red-400 text-xs mb-4 font-mono">{error}</p>}

          <Button data-testid="login-submit" type="submit" disabled={loading}
            className="w-full rounded-none bg-cyan-500 hover:bg-cyan-400 text-black font-semibold tracking-wide transition-transform active:scale-95">
            {loading ? "AUTHENTICATING..." : "ENTER TERMINAL"}
          </Button>
          <p className="text-[10px] text-[#52525b] mt-4 font-mono text-center">default: admin@bot.local / admin123</p>
        </form>
      </div>
    </div>
  );
}
